export default __webpack_public_path__ + "static/media/ourteam1.66b1c9c8.png";